import React from "react";
import styled, { css } from "styled-components";
import { Content } from "./Content";
import { navigateToQuoteForm } from "./QuoteFormAndSafesitePromise";

const PageHeaderStyles = styled.div`
  ${({ ...props }) => css`
    margin-bottom: ${(props.$noSpace ? "0" : "24px")};
    text-align: ${(props.$center ? "center" : "left")};

    div {
      margin-top: 8px;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      margin-bottom: ${(props.$noSpace ? "0" : "32px")};

      div {
        max-width: 75%;
      }
    }
  `}
`;

const StyledHeading = styled.div`
  ${({ ...props }) => css`
    display: flex;
    align-items: center;
    margin: ${(props) =>
      props.$hasButton ? "0 0 16px 0 !important" : "0!important"};

    h1 {
      width: ${(props.$center ? "100%" : "auto")};
    }

    a {
      margin-left: 24px;
      flex-shrink: 0;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      max-width: none !important;
      a {
        margin-left: 32px;
      }
    }
  `}
`;

export default function PageHeader({
  title,
  description,
  noSpace,
  center,
  children,
  button,
  showButton,
}) {
  return (
    <PageHeaderStyles $noSpace={noSpace} $center={center}>
      <StyledHeading $hasButton={showButton} $center={center}>
        <h1>{title}</h1>
        {showButton && button !== "hide" ? (
          <a
            href="javascript:void(0)"
            onClick={navigateToQuoteForm}
            className="button button--secondary"
          >
            {button === "hire" ? "Hire" : "Hire or Buy"}
          </a>
        ) : (
          ""
        )}
      </StyledHeading>
      {children}
      {description && <Content content={description} />}
    </PageHeaderStyles>
  );
}
